import styled from 'styled-components';

const StyledChatToggleButtonBubbleContainer = styled.div`
  font-family: Helvetica, Arial, san-serif;
  align-self: flex-end;
  position: relative;
`;

export default StyledChatToggleButtonBubbleContainer;